import React from 'react';
import DOMPurify from 'dompurify';

const Content = ({ alisaText }) => {
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(
          alisaText
            .trim()
            .replace(/^(?:\n|\\n)/, '')
            .replace(/(?:\n|\\n)/g, '<br />')
        ),
      }}
    />
  );
};

export default Content;
